// submit item/product IDs in a form

import $ from 'jquery';
import { queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const setCombinedIdsOnFormSubmit = () =>
    $('#combined_ids')
      .closest('form')
      .submit((e) => {
        $(e.target)
          .find('#combined_ids')
          .val(queryString().ids || '');
      });

  setCombinedIdsOnFormSubmit();

  // Load new shoppable line items (10 at a time)
  const loadShoppables = (url) => {
    return new Promise((resolve, reject) => {
      $('.shoppables .data-table').after('<div class="shoppables-loading">Loading...</div>');

      const sortAndFilterParams =
        window.location.href.indexOf('?') === -1
          ? ''
          : window.location.href.slice(window.location.href.indexOf('?') + 1);

      $.ajax({
        type: 'GET',
        url: `${url}&${sortAndFilterParams}`,
        data: $('.shoppables__filters').serialize(),
        dataType: 'json',
      })
        .done((data) => {
          $('.shoppables .data-table__table .data-table__tr:last').after(data.html);
          $('.shoppables-loading').remove();

          if (data.next_page === null) {
            $('.data-table__table').removeData('next-page');
          } else {
            $('.data-table__table').data().nextPage = data.next_page;
          }

          if (data.items_next_page === null) {
            $('.data-table__table').removeData('items-next-page');
          } else {
            $('.data-table__table').data().itemsNextPage = data.items_next_page;
          }

          if (data.products_next_page === null) {
            $('.data-table__table').removeData('products-next-page');
          } else {
            $('.data-table__table').data().productsNextPage = data.products_next_page;
          }
          resolve(data);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          $('.shoppables-loading').remove();
          reject(errorThrown);
        });
    });
  };

  // close filter on clicking outside
  $('#add-shoppables-to-billables-from-library, #add-shoppables-to-billables-from-project').on(
    'click',
    (e) => {
      const $dropdown = $(e.target).closest('.filter-list__item');
      if (!$dropdown.length && $('.filter-list__item').hasClass('filter-list__item--open')) {
        $('.filter-list__item').removeClass('filter-list__item--open');
      }
    }
  );

  $(document).on('change', '.checkbox--persist-on-page-reload', (e) => {
    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    // For elements not using data table (grid view)
    $(e.target).closest('.billable-shoppable').toggleClass('billable-shoppable--selected', checked);
  });

  $(function () {
    if (
      !(
        $('body').is('#add-shoppables-to-billables-from-project') ||
        $('body').is('#add-shoppables-to-billables-from-library')
      )
    ) {
      return;
    }

    async function loadShoppablesNextPage($table) {
      if ($table.data().from === 'project') {
        const productsNextPage = parseInt($table.data().productsNextPage) || null;
        const itemsNextPage = parseInt($table.data().itemsNextPage) || null;
        if (
          $('.shoppables-loading').length ||
          (productsNextPage === null && itemsNextPage === null)
        ) {
          return Promise.resolve(false);
        }
        const data = await loadShoppables(
          `${$table.data().url}?product_page=${productsNextPage}&item_page=${itemsNextPage}`
        );

        $table.data('productsNextPage', data.products_next_page);
        $table.data('itemsNextPage', data.items_next_page);

        if (data.products_next_page || data.items_next_page) {
          return true;
        }
        return false;
      } else {
        const nextPage = parseInt($table.data().nextPage) || null;
        if ($('.shoppables-loading').length || nextPage === null) {
          return Promise.resolve(false);
        }
        const checkNextPage = await loadShoppables(`${$table.data().url}?page=${nextPage}`);
        if (checkNextPage.next_page !== null) {
          $table.data('nextPage', checkNextPage.next_page);
          return true;
        } else {
          $table.data('nextPage', null);
          return false;
        }
      }
    }

    function isScrolledToEnd($element) {
      const scrollHeight = $element[0].scrollHeight;
      const clientHeight = $element.outerHeight();
      const scrollTop = $element.scrollTop();

      return scrollTop + clientHeight >= scrollHeight - 100;
    }

    function checkAndLoadPages($this, $table) {
      if (isScrolledToEnd($this)) {
        loadShoppablesNextPage($table).then((loaded) => {
          if (loaded) {
            checkAndLoadPages($this, $table);
          }
        });
      }
    }

    $('.data-table--with-vertical-scroll').scroll((e) => {
      const $this = $(e.target);
      const $table = $this.find('.data-table__table');
      $('.shoppables__back-to-top').toggleClass('hide', $this.scrollTop() === 0);

      checkAndLoadPages($this, $table);
    });

    $(document).ready(() => {
      const $dataTable = $('.data-table--with-vertical-scroll');
      if ($dataTable.length) {
        const $table = $dataTable.find('.data-table__table');
        checkAndLoadPages($dataTable, $table);
      }
    });

    $(document).on('click', '.shoppables__back-to-top', (e) => {
      e.preventDefault();
      $('.data-table--with-vertical-scroll').animate({ scrollTop: 0 }, 'slow');
    });
  });
});
